import { createSelector } from "reselect"

import { getAuthState } from "./getAuthState"

export const getStatus = createSelector(
  getAuthState,
  (authState) => authState.status
)
